export const MODAL_NAMES = {
  EXCLUDE_QUOTE: 'Are you sure you want to exclude this quote?',
  DELETE_QUOTE: 'Are you sure you want to delete this quote?',
};
